/**
 * Converts a dollar amount in string format to a number
 * @example
 * // returns 1234
 * convertCurrencyToDecimal('$1,234.00');
 * @example
 * // returns 1234.56
 * convertCurrencyToDecimal('$1,234.56');
 * convertCurrencyToDecimal('$1,234.56');
 * @param {String} currencyValue Amount in currency format (e.g. $1,234.56)
 * @returns {Decimal} Returns the amount in a decimal format
 */
export function convertCurrencyToDecimal(currencyValue) {
  // Ensure param is a string so we can parse it
  currencyValue = String(currencyValue)

  return currencyValue ? +parseFloat(currencyValue.replace(/[^.0-9]/g, '')).toFixed(2) : 0
}
